(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/blog-new-articles"],{

/***/ "./src/assets/js/blog-new-articles.js":
/*!********************************************!*\
  !*** ./src/assets/js/blog-new-articles.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var NewArticles = /*#__PURE__*/function (_HTMLElement) {
  function NewArticles() {
    var _this;
    _classCallCheck(this, NewArticles);
    _this = _callSuper(this, NewArticles);
    _this.limits = _this.dataset.limit;
    _this.loadLimits = _this.dataset.loadLimit;
    _this.loadButton = _this.querySelector('.blog-new-articles__show-all');
    _this.blogListingTemplateUrl = 'new-articles-request';
    _this.offset = +_this.limits;
    _this.articlesWrapper = _this.querySelector('.blog-new-articles__content__articles');
    _this.filter = "";
    _this.firstFilter = false;
    _this.filterOffset = 0;
    return _this;
  }
  _inherits(NewArticles, _HTMLElement);
  return _createClass(NewArticles, [{
    key: "hideLoadButton",
    value: function hideLoadButton() {
      this.loadButton.classList.remove('tw-block');
      this.loadButton.classList.add('tw-hidden');
    }
  }, {
    key: "showLoadButton",
    value: function showLoadButton() {
      this.loadButton.classList.remove('tw-hidden');
      this.loadButton.classList.add('tw-block');
    }
  }, {
    key: "clearArticles",
    value: function clearArticles() {
      this.articlesWrapper.innerHTML = "";
    }
  }, {
    key: "insertArticles",
    value: function insertArticles(cardsWrapper) {
      var _this2 = this;
      if (this.filter.length > 0) {
        var cards = cardsWrapper.querySelectorAll('.blog-new-articles-card');
        _toConsumableArray(cards).splice(this.filterOffset, this.loadLimits).forEach(function (card) {
          _this2.articlesWrapper.appendChild(card);
        });
        if (_toConsumableArray(cards).splice(this.filterOffset, this.loadLimits).length < +this.loadLimits || cards.length == +this.loadLimits) {
          this.hideLoadButton();
        } else {
          this.showLoadButton();
        }
        this.filterOffset += +this.loadLimits;
      } else {
        this.articlesWrapper.insertAdjacentHTML('beforeend', cardsWrapper.innerHTML);
      }
      this.offset += +this.loadLimits;
    }
  }, {
    key: "loadNewArticles",
    value: function loadNewArticles() {
      var _this3 = this;
      var isCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var url = "".concat(window.location.origin).concat(window.location.pathname, "?view=").concat(this.blogListingTemplateUrl, "&limit=").concat(this.loadLimits, "&offset=").concat(this.offset);
      if (this.filter.length > 0) {
        url = "".concat(window.location.origin).concat(window.location.pathname, "?view=").concat(this.blogListingTemplateUrl, "&limit=", 1000, "&offset=", 0, "&filter=").concat(this.filter);
      }
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (data) {
        var dataDom = new DOMParser().parseFromString(data, 'text/html');
        var cardsWrapper = dataDom.querySelector('.articles-wrapper');
        var cards = cardsWrapper.querySelectorAll('.blog-new-articles-card');
        if (isCheck) {
          if (cards.length) {
            _this3.showLoadButton();
          } else {
            _this3.hideLoadButton();
          }
        } else {
          if (cards.length) {
            _this3.insertArticles(cardsWrapper, _this3.firstFilter);
          } else {
            _this3.hideLoadButton();
          }
        }
        _this3.firstFilter = false;
      });
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this4 = this;
      if (this.loadButton) {
        this.loadButton.addEventListener('click', function () {
          _this4.loadNewArticles(false);
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this5 = this;
      document.addEventListener('DOMContentLoaded', function () {
        _this5.initListeners();
        _this5.loadNewArticles(true);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (customElements.get('new-articles') === undefined) {
  customElements.define("new-articles", NewArticles);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/blog-new-articles.js"));
/******/ }
]);